<template>
  <v-chip :small="small" pill :color="isDraft ? undefined : '#73BDC94D'" :text-color="isDraft ? undefined : 'primary'" class="font-weight-medium px-6">
    {{ isDraft ? 'DRAFT' : 'READY' }}
  </v-chip>
</template>

<script>
export default {
  props: {
    isDraft: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  }
}
</script>
